import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCInput, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { ITypeFinancialManagement } from "src/pages/FinancialManagement/interface";
import { v4 } from "uuid";
import { IIntegration } from "./interface";

const Integrations: React.FC<IIntegration> = ({
	control,
	register,
	integrations,
	type
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fieldsIntegrations, 
		remove: removeIntegrations,
		append: appendIntegrations
	} = useFieldArray({
		control,
		name: "integrations",
		shouldUnregister: true
	});

	const addIntegration = () => {
		const integration: any = {};
		integration.id = "0";
		integration.name = "";

		appendIntegrations(integration);
	};

	const removeIntegration = (index: number) => {			
		removeIntegrations(index);
	};

	useEffect(() => {
		appendIntegrations(integrations.map((integration) => ({
			...integration
		})));
	}, []);

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid
				container
				item
				justifyContent="flex-end"
			>		
				<RCCTooltip
					color="purple"
					text={translate("Adicionar")}
				>
					<RCCButton
						color="purple"
						icon={{
							name: "plus"
						}}
						layout="isRounded"
						size="md"
						onClick={addIntegration}
					/>
				</RCCTooltip>
			</RCCGrid>
								
			<RCCGrid
				container
				item
			>
				{fieldsIntegrations.length === 0 && (
					<RCCAlert
						color="grey"
						title={translate("Nenhum código de integração adicionado")}
						description={translate("Aperte no botão acima para adicionar")}
					/>
				)}
				{fieldsIntegrations.map((miles: any, index) => (					
					<RCCGrid
						container
						item
						alignItems="center"
						key={v4()}
					>
						<input 
							type="text"
							value={miles.id}
							{...register(`integrations[${index}].id`)} 
							style={{ display: "none" }} 
							readOnly
						/>
						<RCCGrid
							container
							item
							justifyContent="center"
							xs={12}
							sm={10}
						>
							<RCCInput 
								register={register}
								name={`integrations[${index}].name`}
								label={type === ITypeFinancialManagement.CENTER_COST ? translate("Cód. Integ. Centro de Custo") : ""}
								maxLength={40}
								defaultValue={miles.name}
								styleInline={type === ITypeFinancialManagement.CENTER_COST ? undefined : "height: 34px;"}
							/>
						</RCCGrid>
						{type === ITypeFinancialManagement.CENTER_COST && (
							<RCCGrid
								container
								item
								justifyContent="center"
								xs={12}
								sm={10}
							>
								<RCCInput 
									register={register}
									name={`integrations[${index}].additionalName`}
									label={translate("Cód. Integ. Conta")}
									maxLength={40}
									defaultValue={miles.additionalName}
								/>
							</RCCGrid>
						)}
						<RCCGrid
							container
							item
							justifyContent="flex-end"
							xs={12}
							sm={2}
						>
							<RCCTooltip
								color="red"
								text={translate("Excluir")}
							>
								<RCCButton
									color="transparent"
									icon={{
										name: "trash",
										color: "var(--red)"
									}}
									layout="isRounded"
									onClick={() => removeIntegration(index)}
									tabIndex={-1}
								/>
							</RCCTooltip>
						</RCCGrid>
					</RCCGrid>										
				))}
			</RCCGrid>
		</RCCGrid>
	);
};

export default Integrations;
